import { createGlobalStyle } from 'styled-components'
import { tooltipStyles } from 'LibNeo/components/Basic/Tooltip/styled'
import { normalize } from './normalize'
import { hexToRgba } from '../utils'
import { themeColor, themeFontFamily, themeFontWeight } from './theme'
import { fonts } from './fonts'

export const GlobalStyle = createGlobalStyle`
  ${normalize}
	${fonts}
  ${tooltipStyles}
  :root {
    // Colors
    ${({ theme }) =>
			Object.keys(theme.colors)
				.map((colorName) =>
					typeof theme.colors[colorName] === 'string'
						? `--colors-${colorName}: ${theme.colors[colorName]};`
						: ''
				)
				.join('')}
    ${({ theme }) =>
			Object.keys(theme.colors.palette)
				.map((paletteName) =>
					Object.keys(theme.colors.palette[paletteName])
						.map(
							(paletteNumber) =>
								`--colors-palette-${paletteName}-${paletteNumber}: ${theme.colors.palette[paletteName][paletteNumber]};`
						)
						.join('')
				)
				.join('')}

    --colors-palette-emerald-6-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.palette.emerald[6], 30)};
    --colors-palette-gold-6-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.palette.gold[6], 30)};
    --colors-palette-pink-7-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.palette.pink[6], 30)};
    --colors-palette-gray-8-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.palette.gray[6], 30)};
    --colors-palette-blue-6-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.palette.blue[6], 30)};

    --colors-extraBackground3-opacity30: ${({ theme }) =>
			hexToRgba(theme.colors.extraBackground3, 30)};
    --colors-extraBackground3-opacity90: ${({ theme }) =>
			hexToRgba(theme.colors.extraBackground3, 90)};

		// Fonts
		--font-family-SBSansText: ${themeFontFamily('SBSansText')};
		--font-family-SBSansInterface: ${themeFontFamily('SBSansInterface')};

		${({ theme }) =>
			Object.keys(theme.font.fontWeight)
				.map((fontFamily) =>
					Object.keys(theme.font.fontWeight[fontFamily])
						.map(
							(fontWeight) =>
								`--font-weight-${fontFamily}-${fontWeight}: ${themeFontWeight(
									fontFamily as any,
									fontWeight as any
								)({ theme })};`
						)
						.join('')
				)
				.join('')}
  }

`

// TODO: перенести в GlobalStyle после переноса всех страниц
export const NeoFontStyle = createGlobalStyle`
  .content-container {
    font-family: ${themeFontFamily('SBSansText')};
    font-weight: ${themeFontWeight('SBSansText', 'regular')};
    font-size: 14px;
    line-height: 20px;
    color: ${themeColor('gray', 8)};
  }
`
